module.exports = __webpack_public_path__ + "static/media/by.76e49e58.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/by.svg
// module id = 2056
// module chunks = 0